import { NavigateFunction } from "react-router"

export const navigateToEditPage = (navigate: NavigateFunction, deviceImei: string) => navigate(`/policies/${deviceImei}/edit`, { state: { imei: deviceImei } })